import { PropsWithChildren } from 'react';
import { PolicyStreamProgressBar } from './PolicyStreamProgressBar';
import { styled } from '@mui/material';
import { PolicyStreamNeedHelp } from './PolicyStreamNeedHelp';
import { useTheme, useMediaQuery } from '@mui/material';

interface PolicyStreamLayoutProps extends PropsWithChildren<{}> {}

export const PolicyStreamLayout = ({ children }: PolicyStreamLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container>
      <SidebarContainer>
        {!isMobile && (
          <>
            <PolicyStreamProgressBar />
            <PolicyStreamNeedHelp />
          </>
        )}
      </SidebarContainer>
      <MainContentsContainer>{children}</MainContentsContainer>
    </Container>
  );
};

const Container = styled('div')(({ theme }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      gap: theme.spacing(4),
      alignItems: 'stretch',
    },
    [theme.breakpoints.down('sm')]: { gap: theme.spacing(1) },
  };
});
const SidebarContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexShrink: 0,
    gap: theme.spacing(1),
    padding: theme.spacing(5, 2, 0, 0),
    maxWidth: '300px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      justifyContent: 'center',
    },
  };
});
const MainContentsContainer = styled('div')({
  flex: 1,
});
